module.exports = __webpack_public_path__ + "img/wave-2.5f07ed59.png";